/**
 * Marquee component
 * -----------------
 */

/* Imports */

import React, { useLayoutEffect } from "react";
import parse from "html-react-parser";
import { Marquee, MarqueeText } from "./styles.module.scss";

/* Component */

const MarqueeComponent = ({
  small = true,
  sticky = false,
  ariaHidden = false,
}) => {
  const str =
    "&nbsp;— Fireside chats — Networking — Expert panels — Live workshops";
  const copies = [];

  for (let i = 0; i < 7; i += 1) {
    copies.push(
      <div
        key={`mq-${i}`}
        className={`${MarqueeText} lc-marquee__text`}
        aria-hidden="true"
      >
        {parse(str)}
      </div>
    );
  }

  useLayoutEffect(() => {
    // get scrollbar width for overflow issue
    document.body.style = `--scrollbar-width: ${
      window.innerWidth - document.documentElement.clientWidth
    }px`;
  }, []);

  return (
    <div
      className={`${Marquee} lc-marquee lc-brown lc-h3-${
        small ? "xxs" : "xs"
      } lc-o-h lc-z-1 lc-fade lc-vis`}
      data-sticky={sticky.toString()}
    >
      <div className="lc-flex">
        <div
          className={`${MarqueeText} lc-marquee__text`}
          aria-hidden={ariaHidden.toString()}
        >
          <span className="lc-v-h">Including activities like </span>
          {parse(str)}
        </div>
        {copies}
      </div>
    </div>
  );
};

/* Export */

export default MarqueeComponent;
